import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { pushQuoteOrderDetailsToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { getQuoteDetails, GetQuoteDetailsApiParameter } from "@NA/Services/ADIGetQuoteDetails";
import { CustomApiHandlerDiscreteParameter } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandlerDiscreteParameter<GetQuoteDetailsApiParameter & HasOnSuccess, OrderModel>;

export const DispatchLoadingQuoteDetails: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchLoadingQuoteDetails",
        result: null,
    });
};

export const RequestDataFromApi: HandlerType = async (props: any) => {
    props.apiParameter = {
        orderNumber: props.parameter.orderNumber,
        // customerSuffix: props.parameter.customerSuffix,
        expand: ["orderLines", "shipments"],
    };

    const customerSuffix = localStorage.getItem("customerSuffix");

    props.apiResult = await getQuoteDetails(props.apiParameter, customerSuffix);
};

export const DispatchCompleteQuoteDetails: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchCompleteQuoteDetails",
        result: props.apiResult,
    });
};

export const SendTrackingCustom: HandlerType = (props: any) => {
    const { invoiceOrderLines } = props.apiResult;
    if (invoiceOrderLines && invoiceOrderLines.length > 0 && invoiceOrderLines[0].invoiceOrderLines !== undefined) {
        pushQuoteOrderDetailsToDataLayer(
            invoiceOrderLines[0].invoiceOrderLines,
            "Quote Details",
            props.getState().context.session,
        );
    }
};

export const chain = [
    DispatchLoadingQuoteDetails,
    RequestDataFromApi,
    DispatchCompleteQuoteDetails,
    SendTrackingCustom,
];

const getQuoteDetailsHandler = createHandlerChainRunner(chain, "GetQuoteDetailsHandler");
export default getQuoteDetailsHandler;
